import React from "react";
import { Locale } from "@linkfluence/models/locale";
import Tile from "@radarly/components/cards/card";
import CardInner from "./card-inner";

interface IProps {
  locale: Locale;
  title?: string;
}

export default function ErrorCardLayout({ locale, title = "" }: IProps) {
  return (
    <Tile title={title}>
      <CardInner locale={locale} />
    </Tile>
  );
}
